import React, { CSSProperties } from "react";

interface IProps {
    color?: string;
    style?: CSSProperties;
    svgWidth?: string;
    svgHeight?: string;
}
const TotumMobileLogo: React.FC<IProps> = (props: IProps) => {
    const { color } = props;
    return (
        <div style={props?.style}>
            <svg
                width={props.svgWidth || "32"}
                height={props.svgHeight || "32"}
                className="images-icon"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 253.5 248"
            >
                <path style={{ fill: "#212c54", stroke: "#000" }} d="M0 0h253.5v248H0z" />
                <path
                    fill={color ? color : "#ffffff"}
                    d="M126.7 25.1c-54.5 0-101 43.8-101 98.9s46.5 98.9 101.1 98.9c54.8 0 101.1-43.6 101.1-98.9s-46.4-98.9-101.2-98.9zm0 177.7c-43.7 0-78.9-35.1-78.9-78.9 0-43.7 35.1-78.9 78.9-78.9 44.1 0 78.9 34.8 78.9 78.9s-34.8 78.9-78.9 78.9z"
                />
                <path
                    fill={color ? color : "#ffffff"}
                    d="M90.6 88.5c2.5 6.4 4.4 13.2 5.5 20.2h19.6V169h20.8v-60.3h25V88.5H90.6z"
                />
            </svg>
        </div>
    );
};

export default TotumMobileLogo;
